import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Departement } from 'src/app/shared/models/departement';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DepartementModalAjoutComponent } from '../modal/departement-modal-ajout/departement-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { DepartementModalDetailComponent } from '../modal/departement-modal-detail/departement-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-departement',
	templateUrl: './list-departement.component.html',
	styleUrls: ['./list-departement.component.scss']
})
export class ListDepartementComponent implements OnInit {
	departement: Departement[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	departementCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editDepartementModalRef: BsModalRef;
	addDepartementModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getDepartement();
		this.isAddable = true;
	}

	getDepartement(): void {
		this.isListingLoading = true;
		this.facade.departementService.getAllDepartement().subscribe({
			next: (val) => {
				this.departement = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.departement.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.departement = [];
			}
		});
	}

	selectDepartement(departement: Departement): void {
		const link = ['/departement', departement.id];
		this.router.navigate(link);
	}

	importDepartement(event: any): void {
		this.departementCsvFile = event.target.files[0];

		this.facade.departementService
			.importDepartement(this.departementCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} departement ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getDepartement();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addDepartementModalRef = this.modalService.show(
			DepartementModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addDepartementModalRef.onHide.subscribe((reason: string | any) => {
			this.getDepartement();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(departement: Departement) {
		const initialState = {
			departement: departement
		};
		this.editDepartementModalRef = this.modalService.show(
			DepartementModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editDepartementModalRef.onHide.subscribe((reason: string | any) => {
			this.getDepartement();
		});
	}
}
